import { Component } from '@angular/core';
import { MenuComponentBase } from '../../../../shared/base-classes/menu-component-base';
import { ManageConnectionComponent } from '../manage-connection/manage-connection.component';

@Component({
  selector: 'app-manage-connection-group',
  standalone: true,
  imports: [ManageConnectionComponent],
  templateUrl: './manage-connection-group.component.html',
  styleUrl: './manage-connection-group.component.scss',
})
export class ManageConnectionGroupComponent extends MenuComponentBase {}
